export default __webpack_public_path__ + "static/media/balcony.679a4ce8.svg";